import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Spinner from "../common/Spinner";
import UserAvatar from 'react-user-avatar';
import * as apiConfig from "../../api/config";

const EventParticipationControl = ({
    participants,
    loading
}) => {

    const [activeForm, setActiveForm] = useState({ form: "going" });

    function setForm(e) {
        e.preventDefault();
        var form = e.target.name;
        setActiveForm(setActiveForm => ({
            ...setActiveForm,
            form: form
        }));
    }

    return (
         loading ? <Spinner /> : (
            <React.Fragment>
                <div className="row justify-content-center">
                    <div className="col-11">
                        <ul className="nav nav-tabs">
                            <li className="nav-item">
                                <a name="going" className={activeForm.form == "going" ? "nav-link active" : "nav-link"} href="#" onClick={setForm}>Going({participants.going.length})</a>
                            </li>
                            <li className="nav-item">
                                <a name="maybe" className={activeForm.form == "maybe" ? "nav-link active" : "nav-link"} href="#" onClick={setForm}>Maybe({participants.maybe.length})</a>
                            </li>
                            <li className="nav-item">
                                <a name="cantgo" className={activeForm.form == "cantgo" ? "nav-link active" : "nav-link"} href="#" onClick={setForm}>Can't Go({participants.cantgo.length})</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="row justify-content-center">
                    <div className="col-11">
                        <ul className="mt-4 all-event-participants">
                        {
                            (() => {
                                switch (activeForm.form) {
                                    case "going":
                                        return (
                                            participants.going.map(user => {
                                                return (
                                                    <li key={user.userId} className="event-participant" title={`${user.firstName} ${user.surname}`} >
                                                        <UserAvatar className="event-participant-avatar" size="40" name={`${user.firstName} ${user.surname}`} src={user.hasAvatar ? `${apiConfig.API_URL}user/avatar/${user.userId}.png` : ""} />
                                                        <div className={"response going"}><span className={"fas fa-check"}></span></div>
                                                        <div className="event-participant-name">{`${user.firstName} ${user.surname}`}</div>
                                                        <hr/>
                                                    </li>
                                                )
                                            })
                                        )
                                        case 'maybe':
                                            return (
                                            participants.maybe.map(user => {
                                                return (
                                                    <li key={user.userId} className="event-participant" title={`${user.firstName} ${user.surname}`} >
                                                        <UserAvatar className="event-participant-avatar" size="40" name={`${user.firstName} ${user.surname}`} src={user.hasAvatar ? `${apiConfig.API_URL}user/avatar/${user.userId}.png` : ""} />
                                                        <div className={"response maybe"}><span className={"fas fa-question"}></span></div>
                                                        <div className="event-participant-name">{`${user.firstName} ${user.surname}`}</div>
                                                        <hr />
                                                    </li>
                                                )
                                            })
                                        )
                                    case 'cantgo':
                                        return (
                                            participants.cantgo.map(user => {
                                                return (
                                                    <li key={user.userId} className="event-participant" title={`${user.firstName} ${user.surname}`} >
                                                        <UserAvatar className="event-participant-avatar" size="40" name={`${user.firstName} ${user.surname}`} src={user.hasAvatar ? `${apiConfig.API_URL}user/avatar/${user.userId}.png` : ""} />
                                                        <div className={"response cantgo"}><span className={"fas fa-times"}></span></div>
                                                        <div className="event-participant-name">{`${user.firstName} ${user.surname}`}</div>
                                                        <hr />
                                                    </li>
                                                )
                                            })
                                        )
                                    default:
                                        return null;
                                }
                            })()
                        }
                        </ul>
                    </div>
                </div>
            </React.Fragment>
        )
    );
}

EventParticipationControl.propTypes = {
    participants: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired
}

export default EventParticipationControl;


// WEBPACK FOOTER //
// ./src/components/events/EventParticipationControl.js